//旅程一起行
export const chimelongTicketRouter = [
  {
    path: '/service/chimelongTicket/pro',
    name: 'ChimelongConnection',
    component: () => import('@/views/service/serviceProvider/chimelongTicket/ChimelongConnection'),
    meta: {
      title: '商品绑定',
      keepAlive: false
    }
  },
  {
    path: '/service/chimelongTicket/order',
    name: 'ChimelongOrderConnection',
    component: () => import('@/views/service/serviceProvider/chimelongTicket/ChimelongOrderConnection'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/chimelongTicket/account',
    name: 'ChimelongNewAccount',
    component: () => import('@/views/service/serviceProvider/chimelongTicket/ChimelongNewAccount'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  },
  {
    path: '/service/chimelongTicket/rules',
    name: 'ChimelongAsyncRule',
    component: () => import('@/views/service/serviceProvider/chimelongTicket/ChimelongAsyncRule'),
    meta: {
      title: '同步规则',
      keepAlive: false
    }
  }
]